import { BASE_AVERAGE_BLOCK_TIME } from 'utils/constants/ethConst';
import { sleep } from 'utils/sleep';

type BalanceData = { value: bigint } | null;
type RefetchResult = { data?: BalanceData };

interface RefetchChangedBalanceParams {
  previousValue?: bigint;
  refetch: () => Promise<RefetchResult>;
  attempts?: number;
  delayMs?: number;
}

export const refetchChangedBalance = async (
  params: RefetchChangedBalanceParams
) => {
  const {
    previousValue,
    refetch,
    attempts = 3,
    delayMs = BASE_AVERAGE_BLOCK_TIME,
  } = params;

  let lastResult: RefetchResult | undefined;
  let lastError: unknown;

  for (let attempt = 0; attempt < attempts; attempt++) {
    try {
      lastResult = await refetch();
      lastError = undefined;

      const nextValue = lastResult.data?.value;
      if (nextValue !== undefined && nextValue !== previousValue) {
        return lastResult;
      }
    } catch (error) {
      lastError = error;
    }

    if (attempt < attempts - 1) {
      await sleep(delayMs);
    }
  }

  if (lastError && !lastResult) {
    throw lastError;
  }

  return lastResult;
};
